import { useConfirmDialog } from '@vueuse/core'

export const confirmDialog = useConfirmDialog<{
  title?: string
  description?: string
  type?: 'success' | 'info' | 'danger'
}>()
